import Layout from "../Layout";
export default [
  {
    path: "/register",
    name: "register",
    component: Layout
  }
];
